import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { fromJS } from "immutable";
import { useTranslation } from "react-i18next";
import InputField from "../components/ui/InputField";
import { Button } from "../components/ui";
import { getTeamInfo, updateTeamInfo } from "../api/TenantApi";
import LayoutAction from "../actions/LayoutAction";

const GeneralSetting = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const currentUser = useSelector((state: any) => state.userReducer.get("currentUser"));
  const isAdmin = currentUser.get("admin");

  const [teamName, setTeamName] = useState("");

  const billingTeamInfoQuery = useQuery({
    queryKey: ["team-info"],
    queryFn: () => getTeamInfo(),
  });
  const billingTeamInfo = fromJS(billingTeamInfoQuery.data || {});
  const tenantName = billingTeamInfo.get("tenantName");

  useEffect(() => {
    setTeamName(tenantName || "");
  }, [tenantName]);

  const handleSave = () => {
    updateTeamInfo({ name: teamName }).then(() => {
      dispatch(
        LayoutAction.setNotification({
          title: t("Update Team"),
          type: "success",
          message: t("Team has been updated"),
        })
      );
    });
  };

  return (
    <div className="py-4 max-w-5xl">
      <div className="px-4 sm:px-0">
        <h3 className="text-lg font-semibold text-gray-900">{t("General")}</h3>
        <p className="mt-1 max-w-2xl text-sm/6 text-gray-500">
          {t("Change the settings for your current Team")}
        </p>
      </div>
      <div className="mt-6">
        <div className="mt-2">
          <InputField label={t("Team ID")} value={billingTeamInfo.get("tenantId")} disabled />
        </div>
        <div className="mt-2">
          <InputField
            label={t("Team Name")}
            placeholder={isAdmin ? t("e.g., Team sales") : undefined}
            value={teamName}
            onChange={(value) => setTeamName(value)}
            disabled={!isAdmin}
          />
        </div>
        {isAdmin ? (
          <div className="mt-4">
            <Button variant="primary" onClick={handleSave}>
              {t("Save")}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default GeneralSetting;
